export default __webpack_public_path__ + "static/media/mailicon.d13fc087.svg";